import React from "react";

const TagWithButton = (props) => {
    return (
        <div className="row bottom-separator-xs">
            <div className="col-md-8 row">

                <div className="col-md-6">
                    <input className="form-control default-input input-disabled-windows-groups" type="text" name="nombre"
                        value={props.productoDescripcion} maxLength="40" data-userinfo="Nombre" disabled />
                </div>
                <div className="col-md-6">
                    <input className="form-control default-input input-disabled-windows-groups" type="text" name="nombre" id="nombre"
                        value={props.codigo} maxLength="40" data-userinfo="Nombre" disabled />
                </div>

               
            </div>

            {(props.configuracionPwType.VincularGrupoWindows == true && props.configuracionPwType.TipoSeguridad == 'AD') ? (null) :
                (<div className="col-md-4">
                    <button id={props.descripcion + props.id}
                        className="btn-text-color-grey btn-transparent delete-button"
                        onClick={() => props.deletePerfilUsuario(props.id)}>X</button>
                </div>)}
        </div>
    );
}

export default TagWithButton;